import { isABN, isACN } from '__core/shared/util/validate';
import template from './contactEmployment.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    employment: '<',
    employments: '<',
    countries: '<',
    location: '<',
    industries: '<',
    occupations: '<',
    validationErrors: '<',
    workflow: '<',
    isFactFind: '<',
    isTicketSettled: '<',
    onEmploymentTypeToggled: '&',
    onEmploymentStartDateChanged: '&',
    onDelete: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      dateTimeService,
      helperService,
      Address,
      ContactEmploymentClass,
      ContactEmploymentPriority,
      ContactEmploymentType,
      PersonalTitle,
      ABNLookupService,
      NZBNLookupService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.organizationCountry = '';
      ctrl.availablePersonalTitles = [];
      ctrl.availableStates = [];
      ctrl.availableContactEmploymentPriorities = [];
      ctrl.availableEmploymentTypes = [];
      ctrl.availableContactEmploymentBasis = [];
      ctrl.availableContactEmploymentClasses = [];

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableContactEmploymentPriorities = ContactEmploymentPriority.available();
        ctrl.availableContactEmploymentTypes = ContactEmploymentType.available();
        ctrl.availableContactEmploymentClasses = ContactEmploymentClass.available();
        ctrl.employment = ctrl.employment || {};
        ctrl.employments = ctrl.employments || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.location = ctrl.location || {};
        ctrl.industries = ctrl.industries || [];
        ctrl.occupations = ctrl.occupations || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.isFactFind = ctrl.isFactFind || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.index = _.findIndex(ctrl.employments, (e) => e?.id === ctrl.employment?.id);
        ctrl.getAvailableContactEmploymentBasis({ employmentType: ctrl.employment?.type });
        dateTimeService.getSet(ctrl, ctrl.employment, 'startDate', 'getSetEmploymentStartDate');
        dateTimeService.getSet(ctrl, ctrl.employment, 'endDate', 'getSetEmploymentEndDate');
        dateTimeService.getSet(
          ctrl,
          ctrl.employment,
          'probationExpiryDate',
          'getSetEmploymentProbationExpiryDate'
        );
      };

      ctrl.getAvailableContactEmploymentBasis = ({ employmentType }) => {
        ctrl.availableContactEmploymentBasis = helperService.getAvailableContactEmploymentBasis(
          {
            employmentType
          }
        );
      };

      ctrl.employmentDelete = ($event) => {
        ctrl.onDelete({ event: $event, idEmployment: ctrl.employment.id });
      };

      ctrl.toggleEmployment = () => {
        if (ctrl.employment.isCurrent) {
          ctrl.employment.endDate = 0;
          ctrl.getSetEmploymentEndDate(null);
        } else {
          ctrl.employment.onProbation = false;
          ctrl.employment.probationExpiryDate = 0;
        }
        ctrl.saveEmployment();
      };

      ctrl.toggleEmploymentType = () => {
        ctrl.getAvailableContactEmploymentBasis({ employmentType: ctrl.employment?.type });
        if (ctrl.isFactFind && ctrl.employment.isCurrent) {
          if (
            ctrl.employment?.type?.name === ContactEmploymentType.salaried_employee.name ||
            ctrl.employment?.type?.name === ContactEmploymentType.self_employed.name
          ) {
            ctrl.removeEmployments(true);
          } else {
            ctrl.removeEmployments(false);
          }
        } else {
          ctrl.saveEmployment();
        }
      };

      ctrl.toggleProbation = () => {
        if (!ctrl.employment.onProbation) {
          ctrl.employment.probationExpiryDate = 0;
          ctrl.getSetEmploymentProbationExpiryDate(null);
        }
        ctrl.saveEmployment();
      };

      ctrl.removeEmployments = (isEmployed) => {
        if (isEmployed) {
          ctrl.employment.startDate = 0;
          ctrl.employment.subTypes.onBenefits = false;
          ctrl.employment.subTypes.student = false;
          ctrl.employment.subTypes.homeDuties = false;
        } else {
          ctrl.employment.status = ContactEmploymentPriority.primary;
          ctrl.employment.basis = '';
          ctrl.employment.role = '';
          ctrl.employment.employerName = '';
          ctrl.employment.employerAddress = Address.blank();
          ctrl.employment.employerContact = '';
          ctrl.employment.employerPhoneCode = '';
          ctrl.employment.employerPhone = '';
          ctrl.employment.employerType = false;
          ctrl.employment.employerAbn = '';
          ctrl.employment.employerAcn = '';
          ctrl.employment.startDate = 0;
          ctrl.employment.endDate = 0;
        }
        ctrl.onEmploymentTypeToggled({ employment: ctrl.employment, isEmployed });
      };

      ctrl.employmentStartDateChange = () => {
        if (
          ctrl.employment?.startDate &&
          moment.utc().diff(moment.utc(ctrl.employment?.startDate, 'X').toDate(), 'days') < 1095
        ) {
          ctrl.onEmploymentStartDateChanged();
        }
        ctrl.saveEmployment();
      };

      ctrl.searchAcnChange = (searchTerm) => {
        ctrl.employment.employerAcn = searchTerm;
        ctrl.saveEmployment();
      };

      ctrl.searchAbsCodes = (query, isIndustryCode) => {
        const lowercaseQuery = String(query).toLowerCase();
        return _.filter(
          isIndustryCode ? ctrl.industries : ctrl.occupations,
          (obj) =>
            obj.id.toString().indexOf(lowercaseQuery) !== -1 ||
            obj.value.toLowerCase().indexOf(lowercaseQuery) !== -1
        );
      };

      ctrl.lookupByBusinessNumberNZ = async (num) => NZBNLookupService.byNZBN({ query: num });
      ctrl.lookupByBusinessNumberAU = async (num) => {
        if (isACN(num)) {
          return ABNLookupService.byACN({ query: num });
        }
        if (isABN(num)) {
          return ABNLookupService.byABN({ query: num });
        }
        return [];
      };
      ctrl.lookupByNameNZ = async (params) => NZBNLookupService.byName(params);
      ctrl.lookupByNameAU = async (params) => ABNLookupService.byName(params);

      ctrl.searchTermNameChange = (searchTerm) => {
        ctrl.employment.employerName = searchTerm;
        ctrl.saveEmployment();
      };

      ctrl.searchTermAbnChange = (searchTerm) => {
        if (!searchTerm || !_.isString(searchTerm)) {
          return;
        }
        ctrl.employment.employerAbn = searchTerm;
        ctrl.saveEmployment();
      };

      ctrl.selectedItemBusinessIdentifierChange = (selectedItem) => {
        if (ctrl.currentOrganization?.organization?.location?.cca2 === 'NZ') {
          if (selectedItem && _.isObject(selectedItem)) {
            ctrl.employment.employerName = selectedItem?.mainName?.organisationName || '';
            ctrl.employment.employerAbn = selectedItem?.nzbn || '';
          }
        }
        if (ctrl.currentOrganization?.organization?.location?.cca2 === 'AU') {
          if (selectedItem && _.isObject(selectedItem)) {
            ctrl.employment.employerName =
              selectedItem?.mainName?.organisationName ||
              selectedItem?.businessName?.organisationName ||
              selectedItem?.name ||
              `${selectedItem?.legalName?.givenName} ${selectedItem?.legalName?.familyName}` ||
              '';
            ctrl.employment.employerAbn = _.isArray(selectedItem?.ABN)
              ? _.find(selectedItem?.ABN, (ABN) => ABN.isCurrentIndicator === 'Y')
                  ?.identifierValue || ''
              : selectedItem?.abn ||
                selectedItem?.nzbn ||
                selectedItem?.ABN?.identifierValue ||
                selectedItem?.ASICNumber ||
                ctrl.employment.employerAbn;
            ctrl.employment.employerAcn =
              selectedItem?.acn || selectedItem?.ASICNumber || ctrl.employment.employerAcn;
          }
        }

        ctrl.saveEmployment();
      };

      ctrl.searchItemChange = (searchText, isAbn) => {
        if (isAbn) {
          ctrl.employment.employerAbn = searchText;
        } else {
          ctrl.employment.employerAcn = searchText;
        }

        ctrl.saveEmployment();
      };

      ctrl.selectedItemNameChange = (selectedItem) => {
        if (ctrl.currentOrganization?.organization?.location?.cca2 === 'NZ') {
          if (!selectedItem || !selectedItem.nzbn) {
            return {};
          }
          ctrl.employment.employerName = selectedItem?.name || '';
          ctrl.employment.employerAbn = selectedItem?.nzbn || '';

          ctrl.saveEmployment();
        }
        if (ctrl.currentOrganization?.organization?.location?.cca2 === 'AU') {
          if (!selectedItem || !selectedItem.Abn) {
            return {};
          }
          ctrl.employment.employerName = selectedItem?.Name || '';
          ctrl.employment.employerAbn = selectedItem?.Abn || '';

          return ctrl.lookupByBusinessNumberAU(selectedItem.Abn).then((result) => {
            if (result && _.isObject(result)) {
              ctrl.employment.employerAcn = result[0]?.ASICNumber || '';
              ctrl.saveEmployment();
            }
          });
        }
        return {};
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveEmployment = () => ctrl.onFinished({ employment: ctrl.employment });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
